import { AnimationType } from '../render/utils/types.mjs';
import { useDomEvent } from '../events/use-dom-event.mjs';

/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useFocusGesture(_ref) {
  var whileFocus = _ref.whileFocus,
    visualElement = _ref.visualElement;
  var animationState = visualElement.animationState;
  var onFocus = function onFocus() {
    animationState && animationState.setActive(AnimationType.Focus, true);
  };
  var onBlur = function onBlur() {
    animationState && animationState.setActive(AnimationType.Focus, false);
  };
  useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
  useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}
export { useFocusGesture };